import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDialog-paper": {
      borderRadius: 12,
      overflow: "hidden",
      maxWidth: 1050,
      width: "92vw",
      margin: 12,
      maxHeight: "92vh",
      boxShadow: "0 15px 20px -5px rgba(0, 0, 0, 0.1), 0 8px 8px -5px rgba(0, 0, 0, 0.04)",
    },
  },
  dialogTitle: {
    backgroundColor: "#000000",
    color: "#ffffff",
    padding: "10px 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  titleText: {
    color: "#ffffff",
    fontSize: "0.95rem",
    fontWeight: 600,
    fontFamily: "'Inter', sans-serif, Roboto",
  },
  closeButton: {
    color: "#ffffff",
    padding: 2,
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.15)",
    },
  },
  closeIcon: {
    fontSize: 20,
    color: "#ffffff",
  },
  dialogContent: {
    backgroundColor: "#ffffff",
    padding: "16px 24px !important",
    overflowY: "auto",
    [theme.breakpoints.down("sm")]: {
      padding: "12px 12px !important",
    },
  },
  topControlsRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 12,
    marginBottom: 16,
  },
  topControlsLeft: {
    display: "flex",
    alignItems: "center",
    gap: 16,
    flexWrap: "wrap",
  },
  serviceTypeSelect: {
    width: 170,
    "& .MuiOutlinedInput-root": {
      borderRadius: 6,
      backgroundColor: "#ffffff",
      fontSize: 12,
      "& fieldset": {
        borderColor: "#cbd5e1",
      },
      "&:hover fieldset": {
        borderColor: "#94a3b8",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#000000",
        borderWidth: 1,
      },
    },
    "& .MuiOutlinedInput-input": {
      padding: "5px 10px",
    },
  },
  switchPillBox: {
    display: "flex",
    alignItems: "center",
    gap: 4,
  },
  switchPillLabel: {
    fontSize: 12,
    fontWeight: 600,
    color: "#334155",
  },
  activeStatusLabel: {
    fontSize: 11,
    fontWeight: 700,
    color: "#64748b",
    letterSpacing: "0.5px",
    textTransform: "uppercase",
    marginRight: 4,
  },
  redSwitch: {
    transform: "scale(0.85)",
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: "#ef4444",
      "& + .MuiSwitch-track": {
        backgroundColor: "#ef4444",
        opacity: 0.9,
      },
    },
    "& .MuiSwitch-track": {
      backgroundColor: "#cbd5e1",
    },
  },
  greenSwitch: {
    transform: "scale(0.85)",
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: "#22c55e",
      "& + .MuiSwitch-track": {
        backgroundColor: "#22c55e",
        opacity: 0.9,
      },
    },
    "& .MuiSwitch-track": {
      backgroundColor: "#cbd5e1",
    },
  },
  sectionTitleHeader: {
    fontSize: 13,
    fontWeight: 700,
    color: "#000000",
    textAlign: "center",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    marginBottom: 4,
    fontFamily: "'Inter', sans-serif, Roboto",
  },
  sectionHeaderDivider: {
    height: 1.5,
    backgroundColor: "#000000",
    width: "100%",
    marginBottom: 10,
    paddingLeft: 10,
  },
  subHeaderRow: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 8,
  },
 subHeaderText: {
  fontSize: "2px",
  fontWeight: 400,
  color: "#64748B",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
},
  fieldRow: {
    display: "flex",
    flexDirection: "column",
    marginBottom: 8,
  },
  fieldLabel: {
    fontSize: "8.5",
    fontWeight: "800",
    color: "#161b22",
    marginBottom: 2,
    
  },
  inputShape: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 6,
      backgroundColor: "#ffffff",
      fontSize: 12,
      color: "#0f172a",
      height: 32,
      "& fieldset": {
        borderColor: "#cbd5e1",
      },
      "&:hover fieldset": {
        borderColor: "#94a3b8",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#000000",
        borderWidth: 1,
      },
    },
    "& .MuiOutlinedInput-input": {
      padding: "4px 8px",
      fontSize: 12,
    },
    "& .MuiFormHelperText-root": {
      fontSize: 10,
      marginTop: 1,
    },
  },
  actionButtonsContainer: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: 12,
    marginTop: 16,
    marginBottom: 2,
  },
  closeButtonAction: {
    minWidth: 100,
    height: 34,
    borderRadius: 6,
    border: "1px solid #cbd5e1",
    color: "#0f172a",
    textTransform: "none",
    fontWeight: 500,
    fontSize: 12,
    backgroundColor: "#ffffff",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#f8fafc",
      borderColor: "#94a3b8",
      boxShadow: "none",
    },
  },
  submitButtonAction: {
    minWidth: 140,
    height: 34,
    borderRadius: 6,
    backgroundColor: "#000000",
    color: "#ffffff",
    textTransform: "none",
    fontWeight: 500,
    fontSize: 12,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#1e293b",
      boxShadow: "none",
    },
  },
}));

export default useStyles;
